import React from 'react'

export const TwitterIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
            <g clipPath="url(#clip0_1_2783)">
                <path d="M20.667 2.79705C19.9181 3.12903 19.1236 3.34678 18.31 3.44305C19.1672 2.93067 19.8084 2.12375 20.114 1.17305C19.3084 1.65111 18.4271 1.98796 17.508 2.16905C17.1243 1.75932 16.6604 1.43284 16.1452 1.2099C15.6299 0.986956 15.0744 0.8723 14.513 0.873051C11.864 0.873051 9.91802 3.34505 10.516 5.91105C8.88458 5.82942 7.28855 5.40555 5.83158 4.66699C4.3746 3.92842 3.08926 2.89167 2.05902 1.62405C1.53476 2.52752 1.37427 3.59675 1.61018 4.61432C1.84609 5.6319 2.46069 6.52143 3.32902 7.10205C2.67738 7.08213 2.03996 6.90658 1.47002 6.59005C1.42502 8.49105 2.78702 10.2701 4.76002 10.6651C4.15573 10.8291 3.52196 10.8531 2.90702 10.7351C3.16891 11.5507 3.67936 12.264 4.36687 12.775C5.05438 13.2861 5.88451 13.5693 6.74102 13.5851C5.02118 14.9341 2.83626 15.5455 0.666016 15.2851C2.5423 16.4904 4.7259 17.1303 6.95602 17.128C14.574 17.128 18.878 10.694 18.618 4.92305C19.4213 4.34217 20.1148 3.62295 20.666 2.79905L20.667 2.79705Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_1_2783">
                    <rect width="21" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
